
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fullDealAndPing3Offers",
      function () {
        return require("private-next-pages/fullDealAndPing3Offers/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fullDealAndPing3Offers"])
      });
    }
  